export default __webpack_public_path__ + "static/media/V680_CoC.f70bce31.pdf";